export const GetCustomersByTaxId = (api, taxId) => {
    return api.get(`/api/v1/Registration/getCustomersByTaxId?taxId=${taxId}`)
}

export const CreateNewAccount = (api, data) => {
    return api.post(`/api/v1/Registration/createNewAccount`, data)
}
export const ActivateAccount = (api, link) => {
    var data = {
        url: link
    }
    return api.post(`/api/v1/Registration/activateAccount`, data)
}